<template>
  <app-modal
    v-if="modal"
    size="confirm"
    @close="deleteConfirmModal()"
  >
    <template #body>
      <section class="modal">
        <p
          v-if="t(modal.title)"
          class="modal__title"
        >
          {{ t(modal.title) }}
        </p>

        <div
          class="margin__t--12"
          v-if="modal.text_to_array.length"
        >
          <p
            v-for="(text, index) in modal.text_to_array"
            :key="`modal_text_${index}`"
            class="modal__text"
          >
            {{ t(text) }}
          </p>
        </div>

        <div class="modal__footer">
          <app-save-button
            class="btn__color--success"
            :is-loading="loader"
            @click="handleConfirmButton()"
          >
            <template #icon>
              <fa-icon
                class="margin__r--6"
                :icon="['far', 'thumbs-up']"
              />
            </template>

            {{ t('literal.confirm') }}
          </app-save-button>

          <button
            class="modal__cancel link__color--danger link--naked"
            :disabled="loader"
            @click.prevent="deleteConfirmModal()"
          >
            <fa-icon
              class="margin__r--6"
              :icon="['fas', 'times']"
            />

            {{ t('literal.cancel') }}
          </button>
        </div>
      </section>
    </template>
  </app-modal>
</template>

<script setup>
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useModalStore } from '@/stores/ModalStore'
import { useI18n } from '@/vendors/i18n'

import AppSaveButton from '&/molecules/AppSaveButton'
import AppModal from '&/organisms/AppModal'

const { t } = useI18n()
const { confirm_modal: modal } = storeToRefs(useModalStore())
const { deleteConfirmModal } = useModalStore()

const loader = ref(false)

const handleConfirmButton = async () => {
  loader.value = true
  await modal.value.callback()
  deleteConfirmModal()
  loader.value = false
}
</script>

<style lang="scss">
.modal {
  padding: 24px;
  text-align: left;

  &__title {
    font-weight: bold;
    width: calc(100% - 24px);
  }

  &__text {
    font-size: 14px;
  }

  &__cancel:disabled {
    color: $lg;
    cursor: not-allowed;
  }

  &__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    gap: 30px;
  }
}
</style>
